import { dictionarydDtail, addDictionaryd, editDictionaryd } from './request';
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true
    },
    isEdit: {
      type: [Boolean, Number, String],
      default: false,
      required: true
    },
    typeList: {
      type: Array,
      default() {
        return [];
      },
      required: true
    },
    roleList: {
      type: Array,
      default() {
        return [];
      },
      required: true
    }
  },
  watch: {
    visible(newV) {
      if (newV && this.$props.isEdit) {
        this.getDetail();
      }
      this.formData = {};
      this.continueState = false;
    }
  },
  data() {
    return {
      formData: {},
      continueState: false
    };
  },
  computed: {
    formFules() {
      return {
        name: [{
          required: true,
          message: this.$t('请输入') + this.$t('字典名称'),
          trigger: 'blur'
        }, {
          message: this.$t('1-50字符'),
          max: 50,
          min: 1
        }],
        mark: [{
          required: true,
          message: this.$t('请输入') + this.$t('标识'),
          trigger: 'blur'
        }, {
          message: this.$t('1-50字符'),
          max: 50,
          min: 1
        }],
        type: [{
          required: true,
          message: this.$t('请选择') + this.$t('字典类型'),
          trigger: 'change'
        }],
        role: [{
          required: true,
          message: this.$t('请选择') + this.$t('使用角色'),
          trigger: 'change'
        }]
      };
    }
  },
  methods: {
    closeAddVisible(e) {
      this.$emit('cancel', e);
      this.$refs.dataFormRef.resetFields();
    },
    // 是否继续添加
    onContinueToAdd(e) {
      this.continueState = e.target.checked;
    },
    async getDetail() {
      this.formData = await dictionarydDtail({
        id: this.$props.isEdit
      });
    },
    handleSure() {
      this.$refs.dataFormRef.validate(async valid => {
        if (valid) {
          if (this.$props.isEdit) {
            await editDictionaryd(this.formData);
          } else {
            await addDictionaryd(this.formData);
          }
          this.$message.success(this.$t('操作成功'));
          this.$emit('save');
          if (!this.continueState) {
            this.$emit('cancel');
          }
          this.$refs.dataFormRef.resetFields();
        }
      });
    }
  }
};